module.exports = __webpack_public_path__ + "static/media/tapir-white.0910b4c1.png";